import { EInfoForTgbActions } from './actionTypes';
import { IBannerEnrichments } from '../../repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';

export type FetchInfoForTgbSuccess = {
  type: EInfoForTgbActions.fetchNewbuildingsInfoForTgbSuccess;
  payload: Record<number, IBannerEnrichments>;
};

export function setNewbuildingsInfoForTgb(payload: Record<number, IBannerEnrichments>): FetchInfoForTgbSuccess {
  return {
    payload,
    type: EInfoForTgbActions.fetchNewbuildingsInfoForTgbSuccess,
  };
}
